import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { timeout } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class EmployeeCostsService {
  constructor(private _httpClient: HttpClient) {}

  async getMonthlyCosts(month: number, year: number) {
    return this._httpClient.get(`/users/monthly-costs/${month}/${year}`).toPromise();
  }

  async updateMonthlyCosts(data: any) {
    return this._httpClient.put("/users/update-monthly-costs", data)
      .pipe(timeout(900000))
      .toPromise();
  }

  async calculateMonthlyCosts(user_hash: string, ral: number) {
    return this._httpClient.get(`/user/calculate-costs/${user_hash}/${Number(String(ral).replace(",", "."))}`).toPromise();
  }

  async getEmployeesTFR(){
    return this._httpClient.get(`/user/tfr`).toPromise()
  }

  async updateEmployeesTFR(data: any){
    return this._httpClient.put(`/user/tfr`, { users_tfr: data }).toPromise();
  }
}
